// Shared container styling constants
export const CONTAINER_STYLES = {
  editMode:
    'mb-4 p-4 border border-gray-200 dark:border-gray-600 rounded-lg bg-blue-50 dark:bg-blue-900/20',
  showMode:
    'mb-4 p-4 border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800',
  input:
    'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100',
} as const;

// Common form field styles
export const FORM_STYLES = {
  label: 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1',
  textarea:
    'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100',
  select:
    'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100',
} as const;

// Common layout styles
export const LAYOUT_STYLES = {
  section: 'space-y-4',
  grid: 'grid gap-4',
  flex: 'flex items-center gap-2',
  spaceBetween: 'flex items-center justify-between',
  centerContent: 'flex items-center justify-center',
} as const;
